import { ModelSagres } from "@/types/model-sagres";
import { ArquivoConvenio } from "../arquivo-convenio";

export class InformacaoCancelamento extends ModelSagres {
    idConvenio: null | number
    numeroConvenio: null  | number
    anoConvenio: null | number
    dataCancelamento: null | Date
    motivoCancelamento: null | string
    arquivoCancelamento: undefined | null  | ArquivoConvenio
    arquivoCancelamentoForm: null
}